module.exports = __webpack_public_path__ + "static/media/home-video-trailer.77ff983a.mp4";